<template>
  <div class="Page">
    <div class="CBox">
      <div class="Logo"></div>
      <div class="Title">ВЫБОРЫ ТАЛИСМАНА</div>
      <div class="Text">
        В июле мы выпустим бесплатный набор стикеров VK Fest — его главным героем станет кандидат, набравший больше всего голосов.
        В подарок за участие в акции вы получите 3 эксклюзивных стикера
        в дополнение к основному набору.
        <br>
        <br>Победитель голосования — надувной и очень красивый — будет ждать вас 20 и 21 июля на центральной аллее VK Fest. Приходите!
      </div>
      <router-link
        tag="button"
        to="/vote"
        replace
        class="OpenVote"
        v-if="options.length+1"
      >ПОСМОТРЕТЬ РЕЗУЛЬТАТЫ</router-link>
    </div>
  </div>
</template>

<script>
import connect from "@vkontakte/vkui-connect-promise";

export default {
  name: "page-Start",
  computed: {
    options() {
      return this.$root.options;
    }
  },
  created() {
    if (window._isMobile) {
      connect.send("VKWebAppSetViewSettings", {
        status_bar_style: "dark",
        action_bar_color: "none"
      });
    } else {
      connect.send("VKWebAppResizeWindow", {
        width: 660,
        height: 492
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.Page {
  background-color: #92e8ff;
  width: 100%;
  height: 447px;
  padding-top: 53px;

  .Logo {
    background-image: url(../assets/vkfest-logo.svg);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 249px;
    height: 50px;
    margin: 0 auto;
  }

  .Title {
    font-family: MabryPro-Black;
    font-size: 28px;
    color: #0102f8;
    letter-spacing: 0;
    text-align: center;
    line-height: 38px;
    margin-top: 30px;
  }

  .Text {
    font-family: MabryPro-Regular;
    font-size: 15px;
    color: #000000;
    letter-spacing: 0;
    text-align: center;
    line-height: 22px;
    width: 510px;
    margin: 31px auto 0;
  }

  button.OpenVote {
    width: 264px; // 154px;
    height: 48px;
    font-family: MabryPro-Black;
    font-size: 14px;
    color: #92e8ff;
    letter-spacing: 0;
    text-align: center;
    line-height: 42px;
    border-radius: 32px;
    background-color: #0000f6;
    margin: 39px auto 0;
    display: block;

    &:hover {
      background-color: #2b2bff;
    }
  }

  @media screen and (max-width: 659px) {
    min-height: -webkit-fill-available;
    height: fit-content;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;

    /* padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top); */

    .CBox {
      margin: auto;
    }

    .Logo {
    }

    .Title {
      font-size: 30px;
      color: #0000f6;
      line-height: 39px;
      max-width: 311px;
      margin: 25px auto 0;
    }

    .Text {
      font-size: 16px;
      color: #000000;
      line-height: 21px;
      width: 91%;
      margin: 30px auto 0;
    }

    button.OpenVote {
      max-width: unset;
      width: 82%;
      height: 64px;
      margin: 36px auto 32px;
      font-size: 16px;
      color: #91e7ff;
    }

    @media screen and (max-height: 620px) {
      padding-top: 20px;

      .Logo {
        display: none;
      }

      .Title {
        margin-top: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Start.vue